<div class="container">
  <!-- Header Section -->
  <div class="row justify-content-between">
    <div class="text-center mb-3">
      <strong class="mainHeading">Registered Users Dashboard</strong>
    </div>
  </div>

  <!-- Dashboard Cards -->
  <div class="row justify-content-between">
    <div class="col-12 col-md-6 col-lg-3 mb-3" *ngFor="let card of summaryCards">

      <!-- Conditional rendering for Requestor card -->
      <div *ngIf="card.title === 'Requestor'">
        <div class="card shadow-sm dashboard-card" [routerLink]="card.route" [style.background-color]="card.color">
          <div class="card-head p-3 border-0 d-flex justify-content-between">
            <!-- Icon and count at the top-left -->
            <i [ngClass]="card.icon + ' fa-2x me-3'" [style.color]="card.textColor"></i>
            <div class="ms-auto text-end">
              <h3 class="card-title mb-0 text-center" [style.color]="card.textColor">{{ card.count }}</h3>
            </div>
          </div>

          <div class="card-body d-flex flex-column justify-content-between" style="height: 107.2px;margin-top: -16px;">
            <div class="d-flex justify-content-between align-items-center">
              <!-- Left side: Individual section -->
              <div class="text-start">
                <strong [style.color]="card.textColor">Individual</strong>
                <p class="card-text" [style.color]="card.textColor">{{ card.individualCount }}</p>
              </div>

              <!-- Divider line between Individual and Corporate -->
              <div class="vr mx-2"></div>

              <!-- Right side: Corporate section -->
              <div class="text-end">
                <strong [style.color]="card.textColor">Corporate</strong>
                <p class="card-text" [style.color]="card.textColor">{{ card.corporateCount }}</p>
              </div>
            </div>

            <div class="text-center">
              <p class="card-text" [style.color]="card.textColor">{{card.title}}</p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="card.title === 'Business Users'">
        <div class="card shadow-sm dashboard-card" [routerLink]="card.route" [style.background-color]="card.color">
          <div class="card-head p-3 border-0 d-flex justify-content-between">
            <!-- Icon and count at the top-left -->
            <i [ngClass]="card.icon + ' fa-2x me-3'" [style.color]="card.textColor"></i>
            <div class="ms-auto text-end">
              <h3 class="card-title mb-0 text-center" [style.color]="card.textColor">{{ card.count }}</h3>
            </div>
          </div>

          <div class="card-body d-flex flex-column justify-content-between" style="height: 107.2px;margin-top: -16px;">
            <div class="d-flex justify-content-between align-items-center">
              <!-- Left side: Individual section -->
              <div class="text-start">
                <strong [style.color]="card.textColor">On business</strong>
                <p class="card-text" [style.color]="card.textColor">{{ card.onBusinessCount  }}</p>
              </div>

              <!-- Divider line between Individual and Corporate -->
              <div class="vr mx-2"></div>

              <!-- Right side: Corporate section -->
              <div class="text-end">
                <strong [style.color]="card.textColor">Off business</strong>
                <p class="card-text" [style.color]="card.textColor">{{ card.offBusinessCount  }}</p>
              </div>
            </div>

            <div class="text-center">
              <p class="card-text" [style.color]="card.textColor">{{card.title}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Non-Requestor Cards -->
      <div *ngIf="card.title !== 'Requestor' && card.title !== 'Business Users'">
        <div class="card shadow-sm dashboard-card" [routerLink]="card.route" [style.background-color]="card.color">
          <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
            <div class="d-flex justify-content-between">
              <i [ngClass]="card.icon + ' fa-2x me-3'" [style.color]="card.textColor"></i>
              <div class="ms-auto text-end">
                <h3 class="card-title mb-0 text-center" [style.color]="card.textColor">{{ card.count }}</h3>
              </div>
            </div>
            <div class="text-center">
              <p class="card-text" [style.color]="card.textColor">{{ card.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Individual and Corporate Requestor Cards -->
  <div class="row mt-1">
    <div class="col-md-6 mt-2">
      <div class="card shadow" style="color: black; overflow: hidden;">
        <div class="modal-header custom-modal-header">
          <h5 class="modal-title mt-2 ms-1">Individual Requestor</h5>
        </div>
        <div class="dropdowns-container d-flex mt-2 p-3">
          <div class="custom-dropdown">
            <select (change)="onCityChange($event, 1)" class="dropdown">
              <option value="">Select City</option>
              <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
            </select>
          </div>

          <div class="custom-dropdown">
            <select (change)="onZoneChange($event, 1)" class="dropdown">
              <option value="">Select Zone</option>
              <option *ngFor="let zone of zoneListIndividual" [value]="zone.zoneId">{{ zone.zoneName }}</option>
            </select>
          </div>
        </div>

        <apx-chart [series]="chartSeriesIndividual" [chart]="chartOptionsIndividual" [labels]="chartLabelsIndividual"
          [dataLabels]="dataLabelsIndividual" [title]="titleIndividual" [colors]="colorsIndividual"
          [plotOptions]="plotOptionsIndividual">
        </apx-chart>
      </div>
    </div>

    <div class="col-md-6 mt-2">
      <div class="card shadow" style="background-color: white; color: black;">
        <div class="modal-header custom-modal-header">
          <h5 class="modal-title mt-2 ms-1">Corporate Requestor</h5>
        </div>
        <div class="dropdowns-container d-flex mt-2 p-3">
          <div class="custom-dropdown">
            <select (change)="onCityChange($event, 2)" class="dropdown">
              <option value="">Select City</option>
              <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
            </select>
          </div>

          <div class="custom-dropdown">
            <select (change)="onZoneChange($event, 2)" class="dropdown">
              <option value="">Select Zone</option>
              <option *ngFor="let zone of zoneListCorporate" [value]="zone.zoneId">{{ zone.zoneName }}</option>
            </select>
          </div>
        </div>

        <apx-chart [series]="chartSeriesCorporate" [chart]="chartOptionsCorporate" [labels]="chartLabelsCorporate"
          [dataLabels]="dataLabelsCorporate" [title]="titleCorporate" [colors]="colorsCorporate"
          [plotOptions]="plotOptionsCorporate">
        </apx-chart>
      </div>
    </div>
  </div>

  <!-- Additional Cards Section -->
  <div class="row">
    <div class="col-md-6 mt-2">
      <div class="card shadow" style="background-color: white; color: black;">
        <div class="modal-header custom-modal-header">
          <h5 class="modal-title mt-2 ms-1">Dumpster</h5>
        </div>
        <div class="dropdowns-container d-flex mt-2 p-3">
          <div class="custom-dropdown">
            <select (change)="onCityChange($event, 3)" class="dropdown">
              <option value="">Select City</option>
              <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
            </select>
          </div>

          <div class="custom-dropdown">
            <select (change)="onZoneChange($event, 3)" class="dropdown">
              <option value="">Select Zone</option>
              <option *ngFor="let zone of zoneListDumpster" [value]="zone.zoneId">{{ zone.zoneName }}</option>
            </select>
          </div>
        </div>

        <apx-chart [series]="chartSeriesDumpster" [chart]="chartOptionsDumpster" [labels]="chartLabelsDumpster"
          [dataLabels]="dataLabelsDumpster" [title]="titleDumpster" [colors]="colorsDumpster"
          [plotOptions]="plotOptionsDumpster">
        </apx-chart>
      </div>
    </div>

    <div class="col-md-6 mt-2">
      <div class="card shadow" style="background-color: white; color: black;">
        <div class="modal-header custom-modal-header">
          <h5 class="modal-title mt-2 ms-1">Dump Yard</h5>
        </div>
        <div class="dropdowns-container d-flex mt-2 p-3">
          <div class="custom-dropdown">
            <select (change)="onCityChange($event, 4)" class="dropdown">
              <option value="">Select City</option>
              <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
            </select>
          </div>

          <div class="custom-dropdown">
            <select (change)="onZoneChange($event, 4)" class="dropdown">
              <option value="">Select Zone</option>
              <option *ngFor="let zone of zoneListDumpyard" [value]="zone.zoneId">{{ zone.zoneName }}</option>
            </select>
          </div>
        </div>

        <apx-chart [series]="chartSeriesDumpyard" [chart]="chartOptionsDumpyard" [labels]="chartLabelDumpyard"
          [dataLabels]="dataLabelsDumpyard" [title]="titleDumpyard" [colors]="colorsDumpyard"
          [plotOptions]="plotOptionsDumpyard">
        </apx-chart>
      </div>
    </div>
  </div>
</div>

<app-loader *ngIf="isPageloading"></app-loader>